import type { IconSvgObject } from './types';

const WirelessIcon: IconSvgObject = [
  ["path", { d: "M18 11H6C4.89543 11 4 11.8954 4 13V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V13C20 11.8954 19.1046 11 18 11Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 15H16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.5 6.99002C10.2106 6.42455 11.0929 6.11744 12.0018 6.11926C12.9106 6.12107 13.7917 6.4317 14.5 7M7 3.7515C8.4189 2.61774 10.1824 2 12 2C13.8176 2 15.5811 2.61774 17 3.7515", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default WirelessIcon;
